import { render, staticRenderFns } from "./UhAlert.vue?vue&type=template&id=39ef4385"
import script from "./UhAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./UhAlert.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports